import type { IButton } from './Button';

import Button from './Button';

export type { IButton };
export default Button;
